export enum ExperienceStatus {
  CONFIRMED = 'confirmed',
  PROPOSAL = 'proposal',
  HIDDEN = 'hidden',
  CANCELED = 'canceled',
}
